@if (showNumber) {
    <div class="timer-number">{{ number }}</div>
}

<div class="circle-shadow">
    <svg [attr.viewBox]="'0 0 100 100'">
        <circle [attr.cx]="centerX" [attr.cy]="centerY" [attr.r]="radius" fill="#1B1E21" stroke="#383D41" stroke-width="10"></circle>
        <path [attr.d]="pathData" [attr.stroke]="color" fill="none" stroke-width="10" stroke-linecap="round" i18n-stroke-linecap />
    </svg>
</div>
